import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import FeatherIcon from "feather-icons-react";

import "./resumenCitas.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

class ResumenCitasAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sede: "",
      sedes: [],
      casos: "",
      icasos: [],
      fechaDia: moment().format("YYYY-MM-DD"),
      fechaSeleccionada: new Date(),
      iespecialistas: [],
      ifilas: [],
      mensajealerta: false,
      tituloM: "",
      cuerpoM: "",
      cargando: false,
      mensajeVacio: "",
      /* MVP estatus */
      estatusOn: false,
      idasociar: "",
      cedulaAlumno: "",
      alumno: "",
      numeroEstatus: "",
      estatusAnterior: "",
      tipoEva: "",
      telefonos: "",
      autorizado: 0,
      fechadeldia: moment().format("YYYY-MM-DD"),
      guardandoEstatus: false,
    };
  }

  componentDidMount() {
    this.cargarSedes();
    this.asociarEvaluacion();
    if (this.props.usuario1 && this.props.usuario1.sede) {
      this.setState({ sede: this.props.usuario1.sede });
    }
  }

  cargarSedes = () => {
    fetchSedes().then((sedes) => {
      this.setState({ sedes: sedes || [] });
    });
  };

  asociarEvaluacion = () => {
    let data = new FormData();
    data.append("boton", "Consultar");
    let config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maestroCasosPHP.php";
    axios.post(xurl, data, config).then((res) => {
      this.setState({ icasos: res.data || [] });
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onClickDay = (e) => {
    const fecha = moment(e).format("YYYY-MM-DD");
    this.setState(
      {
        fechaSeleccionada: e,
        fechaDia: fecha,
      },
      () => {
        if (this.state.sede && this.state.casos) {
          this.consultarResumen();
        }
      }
    );
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  etiquetaEstatus = (est) => {
    const e = String(est);
    const map = {
      "1": "Sin Confirmar",
      "2": "Confirmado",
      "3": "En Consulta",
      "4": "Pagado",
      "5": "Anulado",
      "6": "No Asistio",
      "7": "En Espera",
      "8": "No Cobrado",
      "9": "Donación",
      "10": "Cancelado",
      "11": "Cambio",
      "12": "Factura Pendiente",
      "14": "Modificar Estudio",
      "15": "No Asistio (Pagado)",
      "16": "Cancelado (Pagado)",
    };
    return map[e] || "Estatus " + e;
  };

  puedeCambiarEstatus = () => {
    const diaCita = this.state.fechaDia;
    const hoy = this.state.fechadeldia;
    if (this.state.autorizado === 1 || this.state.autorizado === "1") return true;
    return diaCita >= hoy;
  };

  verMensaje = (e, mensaje) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const txt = String(mensaje || "").trim();
    if (!txt) return;
    this.setState({
      mensajealerta: true,
      tituloM: "Mensaje del reporte",
      cuerpoM: txt,
    });
  };

  cerrarEstatus = () => {
    this.setState({
      estatusOn: false,
      idasociar: "",
      cedulaAlumno: "",
      alumno: "",
      numeroEstatus: "",
      estatusAnterior: "",
      tipoEva: "",
      telefonos: "",
      autorizado: 0,
      guardandoEstatus: false,
    });
  };

  abrirEstatus = (celda, hora) => {
    const idasociarE = celda && celda.variable7 ? String(celda.variable7) : "";
    if (!idasociarE) return;
    const texto = celda.variable2 || "";
    const nombre = texto.indexOf(":") >= 0
      ? texto.substring(texto.indexOf(":") + 1).trim()
      : texto;
    const estatusCelda = celda.variable3 ? String(celda.variable3) : "1";

    let data = new FormData();
    data.append("idasociarE", idasociarE);
    data.append("fechadia", this.state.fechaDia);
    data.append("sede", this.state.sede);
    data.append("boton", "consultarstatus");
    let config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)
      .then((res) => {
        if (res.data && res.data.variable1) {
          this.setState({
            estatusOn: true,
            idasociar: idasociarE,
            alumno: nombre,
            cedulaAlumno: res.data.variable3 || celda.variable8 || "",
            numeroEstatus: String(res.data.variable2 || estatusCelda),
            estatusAnterior: String(res.data.variable2 || estatusCelda),
            tipoEva: res.data.variable4 || "",
            telefonos: res.data.variable14 || "",
            autorizado: res.data.variable10 || 0,
            fechadeldia: moment().format("YYYY-MM-DD"),
          });
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Resumen Citas",
            cuerpoM: "No se pudo consultar el estatus de la cita.",
          });
        }
      })
      .catch(() => {
        this.setState({
          mensajealerta: true,
          tituloM: "Resumen Citas",
          cuerpoM: "Error de comunicación al consultar el estatus.",
        });
      });
  };

  actualizarEstatus = (estatusNuevo) => {
    if (!this.state.idasociar || !estatusNuevo) return;
    this.setState({ guardandoEstatus: true });
    let data = new FormData();
    data.append("fechadia", this.state.fechaDia);
    data.append("idasociarE", this.state.idasociar);
    data.append("estatus", estatusNuevo);
    data.append("nota", "");
    data.append("boton", "actualizarEstatus");
    let config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)
      .then((res) => {
        if (res.data && res.data.variable1) {
          this.cerrarEstatus();
          this.consultarResumen();
        } else {
          this.setState({
            guardandoEstatus: false,
            mensajealerta: true,
            tituloM: "Resumen Citas",
            cuerpoM:
              (res.data && res.data.variable2) ||
              "No se pudo actualizar el estatus.",
            numeroEstatus: this.state.estatusAnterior,
          });
        }
      })
      .catch(() => {
        this.setState({
          guardandoEstatus: false,
          mensajealerta: true,
          tituloM: "Resumen Citas",
          cuerpoM: "Error de comunicación al actualizar el estatus.",
          numeroEstatus: this.state.estatusAnterior,
        });
      });
  };

  onChangeEstatus = (e) => {
    const valor = e.target.value;
    if (!valor) return;
    /* MVP: solo estatus simples (sin facturar, anular, no asistio, cancelado, cambio, pendiente, estudio) */
    const simples = ["1", "2", "3", "7", "8", "9"];
    if (simples.indexOf(valor) >= 0) {
      this.setState({ numeroEstatus: valor }, () => {
        this.actualizarEstatus(valor);
      });
    } else {
      this.setState({
        numeroEstatus: this.state.estatusAnterior,
        mensajealerta: true,
        tituloM: "Resumen Citas",
        cuerpoM:
          "Ese estatus no está disponible en Resumen. Use el módulo Citas para facturar u otras acciones.",
      });
    }
  };

  consultarResumen = () => {
    if (!this.state.sede || !this.state.casos || !this.state.fechaDia) {
      this.setState({
        mensajealerta: true,
        tituloM: "Resumen Citas",
        cuerpoM: "Debe seleccionar sede, especialidad y fecha.",
      });
      return;
    }
    this.setState({ cargando: true });
    let data = new FormData();
    data.append("sede", this.state.sede);
    data.append("tipoEvaluacion", this.state.casos);
    data.append("fechaDia", this.state.fechaDia);
    data.append("boton", "consultarResumenCitas");
    let config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/resumenCitas.php";
    axios
      .post(xurl, data, config)
      .then((res) => {
        if (res.data && res.data.variable1) {
          const esp = res.data.variable2 || [];
          const filas = res.data.variable3 || [];
          this.setState({
            iespecialistas: esp,
            ifilas: filas,
            cargando: false,
            mensajeVacio:
              esp.length === 0
                ? res.data.variable4 ||
                  "No hay citas para la especialidad y fecha seleccionadas."
                : "",
          });
        } else {
          this.setState({
            iespecialistas: [],
            ifilas: [],
            cargando: false,
            mensajeVacio: "",
            mensajealerta: true,
            tituloM: "Resumen Citas",
            cuerpoM:
              (res.data && res.data.variable4) ||
              "No se pudo consultar el resumen.",
          });
        }
      })
      .catch(() => {
        this.setState({
          iespecialistas: [],
          ifilas: [],
          cargando: false,
          mensajealerta: true,
          tituloM: "Resumen Citas",
          cuerpoM: "Error de comunicación al consultar el resumen.",
        });
      });
  };

  chunkEspecialistas = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) {
      out.push(arr.slice(i, i + size));
    }
    return out;
  };

  nombreDia = () => {
    const m = moment(this.state.fechaDia, "YYYY-MM-DD");
    const txt = m.format("dddd D [de] MMMM [de] YYYY");
    return txt.charAt(0).toUpperCase() + txt.slice(1);
  };

  renderTabla = (grupoEsp, idxGrupo) => {
    const cedulas = grupoEsp.map((e) => e.variable1);
    return (
      <div className="rc-tabla-wrap" key={"g-" + idxGrupo}>
        <div className="rc-fila rc-header">
          <div className="rc-hora">HORA</div>
          {grupoEsp.map((esp) => (
            <div className="rc-celda-h" key={esp.variable1} title={esp.variable2}>
              {esp.variable2}
            </div>
          ))}
        </div>
        {this.state.ifilas.map((fila) => {
          const cells = fila.variable2 || [];
          const mapCell = {};
          cells.forEach((c) => {
            mapCell[c.variable1] = c;
          });
          const hayEnGrupo = cedulas.some(
            (ced) => mapCell[ced] && mapCell[ced].variable2
          );
          if (!hayEnGrupo) return null;
          return (
            <div className="rc-fila" key={fila.variable1 + "-" + idxGrupo}>
              <div className="rc-hora">{fila.variable1}</div>
              {cedulas.map((ced) => {
                const c = mapCell[ced];
                const texto = c && c.variable2 ? c.variable2 : "";
                const icono = c && c.variable4 ? c.variable4 : "";
                const iconoEsp = c && c.variable5 ? c.variable5 : "";
                const mensaje = c && c.variable6 ? String(c.variable6).trim() : "";
                const estatus = c && c.variable3 ? String(c.variable3) : "";
                const idasociarE = c && c.variable7 ? String(c.variable7) : "";
                return (
                  <div
                    className={
                      texto
                        ? "rc-celda ocupada" + (idasociarE ? " rc-clickable" : "")
                        : "rc-celda vacia"
                    }
                    key={ced + "-" + fila.variable1}
                    title={texto ? "Clic para cambiar estatus" : ""}
                    onClick={() => {
                      if (texto && idasociarE) this.abrirEstatus(c, fila.variable1);
                    }}
                  >
                    {texto !== "" && (
                      <span className="rc-celda-inner">
                        <span className="rc-iconos">
                          {estatus !== "15" && estatus !== "16" && icono !== "" && (
                            <FeatherIcon
                              className={icono}
                              icon={icono}
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                          {estatus === "15" && (
                            <FeatherIcon
                              className="dolar"
                              icon="dollar-sign"
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                          {estatus === "15" && (
                            <FeatherIcon
                              className="noasistio"
                              icon="x-circle"
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                          {estatus === "16" && (
                            <FeatherIcon
                              className="dolar"
                              icon="dollar-sign"
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                          {estatus === "16" && (
                            <FeatherIcon
                              className="cancelado"
                              icon="x-square"
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                          {iconoEsp !== "" && (
                            <FeatherIcon
                              className={iconoEsp}
                              icon={iconoEsp}
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                          {iconoEsp === "camera" && mensaje !== "" && (
                            <span
                              className="rc-mail-btn"
                              title="Ver mensaje"
                              onClick={(ev) => this.verMensaje(ev, mensaje)}
                            >
                              <FeatherIcon
                                className="mail"
                                icon="mail"
                                size="12px"
                                stroke="currentColor"
                              />
                            </span>
                          )}
                          {iconoEsp === "camera" && mensaje === "" && (
                            <FeatherIcon
                              className="mail1"
                              icon="mail"
                              size="12px"
                              stroke="currentColor"
                            />
                          )}
                        </span>
                        <span className="rc-texto">{texto}</span>
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const grupos = this.chunkEspecialistas(this.state.iespecialistas, 6);
    const est = String(this.state.numeroEstatus);
    const puedeCambiar = this.puedeCambiarEstatus();
    const bloqueadoCobro =
      est === "4" ||
      est === "5" ||
      est === "11" ||
      est === "13" ||
      est === "15" ||
      est === "16";

    return (
      <div className="principal-pago row">
        <div className="contenedor-cxcP col-12">
          <div className="titulo-cxc">
            <p>RESUMEN CITAS.</p>
          </div>

          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}

          {this.state.estatusOn && (
            <div className="rc-modal-overlay">
              <div className="rc-modal">
                <div className="rc-modal-titulo">
                  CAMBIAR ESTATUS
                </div>
                <div className="rc-modal-paciente">
                  {this.state.alumno}
                  {this.state.cedulaAlumno
                    ? " — " + this.state.cedulaAlumno
                    : ""}
                </div>
                {this.state.tipoEva !== "" && (
                  <div className="rc-modal-meta">{this.state.tipoEva}</div>
                )}
                {this.state.telefonos !== "" && (
                  <div className="rc-modal-meta">
                    Teléfonos: {this.state.telefonos}
                  </div>
                )}
                <div className="rc-modal-meta">
                  Día: {this.state.fechaDia} · Actual:{" "}
                  <strong>{this.etiquetaEstatus(est)}</strong>
                </div>

                {puedeCambiar && !bloqueadoCobro && (
                  <div className="rc-modal-campo">
                    <label>Nuevo estatus</label>
                    <select
                      id="numeroEstatus"
                      name="numeroEstatus"
                      value={this.state.numeroEstatus}
                      onChange={this.onChangeEstatus}
                      disabled={this.state.guardandoEstatus}
                    >
                      <option value="">-Seleccione Estatus-</option>
                      <option value="1">Sin Confirmar</option>
                      {(est === "1" || est === "2") && (
                        <option value="2">Confirmado</option>
                      )}
                      {est !== "1" && <option value="3">En Consulta</option>}
                      {est !== "1" && <option value="7">En Espera</option>}
                      {est !== "1" && <option value="8">No Cobrado</option>}
                      {est !== "1" && <option value="9">Donación</option>}
                    </select>
                    <p className="rc-modal-hint">
                      Para Facturar, Anular, No Asistió, Cancelado u otras
                      acciones use el módulo Citas.
                    </p>
                  </div>
                )}

                {bloqueadoCobro && (
                  <p className="rc-modal-hint">
                    Este estatus ({this.etiquetaEstatus(est)}) no se modifica
                    desde Resumen. Use el módulo Citas.
                  </p>
                )}

                {!puedeCambiar && !bloqueadoCobro && (
                  <p className="rc-modal-hint">
                    Solo se puede cambiar estatus desde el día de la cita en
                    adelante (misma regla que Citas).
                  </p>
                )}

                <div className="rc-modal-acciones">
                  <button className="boton" onClick={this.cerrarEstatus}>
                    Salir
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="rc-filtros row">
            <div className="cont-personal col-auto">
              <label className="labelp">Sede.</label>
              <select
                id="sede"
                name="sede"
                value={this.state.sede}
                onChange={this.onChange}
              >
                <option value="">-Sede-</option>
                {this.state.sedes.map((item, i) => (
                  <option key={i} value={item.variable1}>
                    {item.variable2}
                  </option>
                ))}
              </select>
            </div>
            <div className="cont-personal col-auto">
              <label className="labelp">Especialidad.</label>
              <select
                id="casos"
                name="casos"
                value={this.state.casos}
                onChange={this.onChange}
              >
                <option value="">-Especialidad-</option>
                {Array.isArray(this.state.icasos) &&
                  this.state.icasos.map((item, i) => (
                    <option key={i} value={item.variable1}>
                      {item.variable2}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="rc-acciones">
            <button
              className="boton"
              onClick={this.consultarResumen}
              disabled={this.state.cargando}
            >
              Consultar Horario
            </button>
            <button
              className="boton"
              onClick={this.consultarResumen}
              disabled={this.state.cargando}
            >
              Actualizar
            </button>
            <Link to="/">
              <button className="boton">Salir</button>
            </Link>
          </div>

          <div className="rc-fecha-activa">
            Día seleccionado: <strong>{this.nombreDia()}</strong>
            {"  "}({this.state.fechaDia})
          </div>

          <div className="rc-layout">
            <div className="rc-izquierda">
              <Calendar
                onClickDay={this.onClickDay}
                value={this.state.fechaSeleccionada}
              />
              <div className="rc-leyenda">
                <div>
                  <FeatherIcon icon="help-circle" size="14" /> Sin Confirmar
                </div>
                <div>
                  <FeatherIcon icon="edit-3" size="14" /> Confirmado
                </div>
                <div>
                  <FeatherIcon icon="check" size="14" /> En Consulta
                </div>
                <div>
                  <FeatherIcon icon="dollar-sign" size="14" /> Facturar ó Pagado
                </div>
                <div>
                  <FeatherIcon icon="x" size="14" /> Anulado
                </div>
                <div>
                  <FeatherIcon icon="x-circle" size="14" /> No Asistio
                </div>
                <div>
                  <FeatherIcon icon="clock" size="14" /> En Espera
                </div>
                <div>
                  <FeatherIcon icon="user-minus" size="14" /> No Cobrado
                </div>
                <div>
                  <FeatherIcon icon="user-check" size="14" /> Donación
                </div>
                <div>
                  <FeatherIcon icon="x-square" size="14" /> Cancelado
                </div>
                <div>
                  <FeatherIcon icon="chevron-down" size="14" /> Factura Pendiente
                </div>
                <div>
                  <FeatherIcon icon="camera" size="14" /> Con reporte
                </div>
                <div>
                  <FeatherIcon icon="camera-off" size="14" /> Sin reporte
                </div>
                <div>
                  <FeatherIcon icon="mail" size="14" /> Mensaje reporte (clic)
                </div>
              </div>
            </div>

            <div className="rc-derecha">
              {this.state.cargando && (
                <div className="rc-cargando">Consultando...</div>
              )}
              {!this.state.cargando && grupos.length === 0 && (
                <div className="rc-vacio">
                  {this.state.mensajeVacio
                    ? this.state.mensajeVacio
                    : "Seleccione sede, especialidad y un día del calendario, luego Consulte / Actualice."}
                </div>
              )}
              {!this.state.cargando &&
                grupos.map((grupo, idx) => this.renderTabla(grupo, idx))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
  };
};

export default connect(mapStateToProps, null)(ResumenCitasAction);
